<script setup lang="ts">
import '@hprofits/ui/style.css';
import '@hprofits/ui-smart-controls/style.css';

import { PageShell, PageShellContent } from '@hprofits/ui';

import { useBlacklistEditorContextProvider } from '../../views/BlacklistAutoRuleEditor/composables/context/useBlacklistEditorContextProvider';
import BlacklistAutoRuleEditorHeader from './BlacklistAutoRuleEditorHeader.vue';

defineOptions({ name: 'BlacklistAutoRuleEditorLayout' });

useBlacklistEditorContextProvider();
</script>

<template>
  <PageShell class="hp-ui-boundary">
    <BlacklistAutoRuleEditorHeader />
    <PageShellContent>
      <slot />
    </PageShellContent>
  </PageShell>
</template>
